import { BoxV2 as Box, DropdownV2 as Dropdown, Flex } from 'portal-commons';
import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { faBullhorn } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { nominateCnpApi } from '../apiServices';
import IntegrationReactSelect from '@/ui_elements/IntegrationReactSelect';
import { toastFlashMessage } from '@/utils';

export default function ElectCNPDialog(props) {
  const {
    cnpOptions,
    open,
    campaignUid,
    title = 'Elect Connectivity Partner',
    variant, // 'csp' or 'cnp'
    mode = 'elect', // 'elect' or 'change'
    currentUpstreamCnpUid,
  } = props;
  const [error, setError] = useState({});
  const [nominee, setNominee] = useState('');
  const [loader, setLoader] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    const validateNewInput = {
      nominee: nominee ? '' : 'Please elect Connectivity Partner',
    };
    if (
      Object.keys(validateNewInput).every((key) => validateNewInput[key] == '')
    ) {
      const cnp = cnpOptions.find((option) => option.value === nominee)?.label;
      if (mode === 'change' && nominee === currentUpstreamCnpUid) {
        setLoader(false);
        toastFlashMessage(
          `${cnp} successfully elected as connectivity partner`,
          'success'
        );
        props.handleClose('elect', true);
      } else {
        nominateCnpApi(campaignUid, nominee).then((response) => {
          setLoader(false);
          if (response.status >= 200 && response.status < 300) {
            toastFlashMessage(
              `${cnp} successfully elected as connectivity partner`,
              'success'
            );
            props.handleClose('elect', true);
          }
        });
      }
    } else {
      setLoader(false);
      setError(validateNewInput);
    }
  };
  useEffect(() => {
    setError({});
    setNominee('');
  }, [open]);

  return (
    <Dialog
      open={open}
      // onClose={props.handleClose}
      aria-labelledby="responsive-dialog-title"
      className="elect-cnp-dialog"
      data-testid="electCnpDialog"
    >
      <DialogContent className="content-wrapper">
        <div
          className="title text-center"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
          }}
        >
          <Flex
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              width: 24,
              height: 24,
              fontSize: 22,
              lineHeight: 0,
            }}
          >
            <FontAwesomeIcon icon={faBullhorn} />
          </Flex>
          <h3
            className="heading1"
            style={{ fontWeight: 600, fontSize: 24, lineHeight: 'normal' }}
          >
            {title}
          </h3>
        </div>
        <p className="paragraph">
          Please select the partner who will receive the messaging campaign.{' '}
          {variant === 'cnp' && mode === 'elect' && (
            <strong>
              By making a selection, you are automatically accepting the shared
              campaign.{' '}
            </strong>
          )}
          Failing to elect a CNP may prevent it from reaching the MNO.
          <br />
          <br />
          For Sole Proprietor campaigns: If your CNP is not shown in the list,
          they are not configured to receive those types of campaigns. Please
          reach out to your CNP for more information.
        </p>
        <p className="note" style={{ marginBottom: 16 }}>
          * Indicates a Required Field
        </p>
        <form noValidate onSubmit={handleSubmit}>
          <Dropdown
            testid="editElectConnectivityPartnerSelect"
            required
            error={!!error.nominee}
            label="Elect Connectivity Partner"
            helperText={error.nominee}
            options={cnpOptions}
            value={cnpOptions.find((option) => option.value === nominee)}
            onChange={(value) => {
              setNominee(value);
              setError({ nominee: '' });
            }}
          />
          <ul className="list-inline footer" style={{ marginTop: 24 }}>
            <li>
              <a
                className={`secondary-btn ${loader ? 'disabled' : ''}`}
                onClick={() => props.handleClose('elect', false)}
                data-testid="electCnpDialogCancelButton"
              >
                Cancel
              </a>
            </li>
            <li className="form-group-field">
              <input
                data-testid="electCnpDialogSubmitButton"
                type="submit"
                disabled={loader ? true : false}
                value="Proceed"
              />
            </li>
          </ul>
        </form>
      </DialogContent>
    </Dialog>
  );
}
